<template>
  <div id="osNav">
    <!-- 顶部信息 -->
    <el-header />

    <!-- 测导航 -->
    <div class="top">
      <user-info />
    </div>
    <div class="bottom">
      <nav-module />
    </div>
  </div>
</template>

<script>
import elHeader from "./components/elHeader.vue";
import userInfo from "./components/userInfo.vue";
import navModule from "./components/nav-left.vue";
export default {
  name: "osNav",
  components: { userInfo, navModule, elHeader },
};
</script>

<style scoped>
#osNav {
  background-color: rgb(84, 92, 100);
  padding-top: 80px;
}

#osNav ul {
  height: 100%;
}

#osNav .bottom {
  height: calc(100vh - 180px);
  overflow: auto;
}

#osNav .bottom::-webkit-scrollbar {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/osNav/osNav.vue